<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="left"><a id="p3"></a> Hear this, all ye people;</p>
<p class="left">      give ear all ye inhabitants of the world.</p>
<p class="timebreak"> <br/></p>
<p class="center">—Psalm 49</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?26f7b737